import { render, staticRenderFns } from "./CommunitySideMenu.vue?vue&type=template&id=99459bc6&scoped=true&"
import script from "./CommunitySideMenu.vue?vue&type=script&lang=js&"
export * from "./CommunitySideMenu.vue?vue&type=script&lang=js&"
import style0 from "./CommunitySideMenu.vue?vue&type=style&index=0&id=99459bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99459bc6",
  null
  
)

export default component.exports